// import forest from "../assets/forest.jpg";
// import forest_day from "../assets/forest_day.jpg";
// import reforestation from "../assets/reforestation.jpg";
// import reforestation_campaign from "../assets/reforestation_campaign.jpg";
// import ora from "../assets/seminar_member.jpg";
import env_health from "../assets/environmental_health_1.jpeg";
import resilience from "../assets/resilience_1.jpeg";
import indigineous from "../assets/indigenous_1.jpeg";
import organizational_effectiveness from "../assets/organizational_effectiveness.jpeg";


export const MenuList = [
  {
    name: "",
    image: resilience,
    description: 'We strive to strengthen community resilience to climate change through climate adaptation measures, early warning systems, disaster risk reduction, ecosystem restoration, and sustainable environmental practices.',
  },
  {
    name: "",
    image: indigineous,
    description: 'We work to advance the integration, documentation, and application of Indigenous knowledge and scientific research to address climate, environmental, health, and development challenges.',
  },
  {
    name: "",
    image: env_health,
    description: 'We promote environmental health and sustainable livelihoods through awareness, clean energy solutions, climate-sensitive practices, and responsible natural resource management.',
  },
  {
    name: "",
    image: organizational_effectiveness,
    description: 'We enhance organizational effectiveness and sustainability through good governance, strategic partnerships, capacity development, and resource mobilization.',
  },
  // {
  //   name: "Environmental Conservation",
  //   image: forest,
  //   description: 'Leading tree planting and waste segregation initiatives, like our work at Kisewe Primary School, to foster sustainability.',
  // },
  // {
  //   name: "Community Resilience Building",
  //   image: forest_day,
  //   description: 'Enhancing climate change adaptability and providing resources for orphans, elders, and disabled groups',
  // },
  // {
  //   name: "Road Safety Awareness",
  //   image: reforestation,
  //   description: 'Road Safety Awareness: Educating communities near construction sites, as seen in our projects with STECOL and Sinohydro, to ensure safer environments.',
  // },
  // {
  //   name: "WASH Programs",
  //   image: reforestation_campaign,
  //   description: 'Promoting health and hygiene through water, sanitation, and hygiene initiatives. Ready to collaborate? Reach out to see how GDFB can support your community’s growth!',
  // },
  // {
  //   name: "Health and Safety Education",
  //   image: seminar_member,
  //   description: 'Conducting HIV/AIDS and STI awareness campaigns, including pre- and post-test counseling, to promote healthier communities.',
  // },
];
